import { render } from "./TheShare.vue?vue&type=template&id=4cf286a8&scoped=true"
import script from "./TheShare.vue?vue&type=script&lang=js"
export * from "./TheShare.vue?vue&type=script&lang=js"

import "./TheShare.vue?vue&type=style&index=0&id=4cf286a8&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf286a8"]])

export default __exports__